import axios, { AxiosError, HttpStatusCode } from "axios";
import store from "../store";
import { handleToastState } from "../slices/shared";
import { logout } from "../slices/auth";

const axiosErrorInterceptor = async (error: Error | AxiosError) => {
  const { dispatch } = store;

  let message = "Something happened! Please try again.";

  if (axios.isAxiosError(error)) {
    if (error.response?.status === HttpStatusCode.Unauthorized) {
      message = "Must be logged in to do that!";
      dispatch(logout());
    } else if (error.response?.status === HttpStatusCode.Forbidden) {
      message = "Not authorized to do that!";
    } else if (error?.response?.data?.message) {
      message = error.response?.data.message;
    } else {
      message = error.message;
    }
  } else {
    message = error.message;
  }
  dispatch(handleToastState({ open: "error", message: `Error: ${message}` }));
};

export default axiosErrorInterceptor;
